// services/frontend/src/pages/AdminPanel.tsx
import { ServiceHealthDashboard } from '../components/composed/ServiceHealthDashboard';

export function AdminPanel() {
  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground mb-4">Admin Panel</h1>
      </div>
      <ServiceHealthDashboard />
    </div>
  );
}
